const initialState = {
  brs: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "RE_SELECT":
      return {
        ...state,
        brs: action.payload,
      };
    default:
      return state;
  }
}
